var map = {
	"./standard.js": "./src/project-types/standard.js"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 89;



//////////////////
// WEBPACK FOOTER
// ./src/project-types nonrecursive .js$
// module id = 89
// module chunks = 0 1 2 3 4 5 6 7